import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Quote } from '../types/quote.type';
import { QUOTES_API_PATHS } from '../constants/quotes-paths.constants';

type UseDuplicateQuoteResult = {
  duplicateQuote: (id: string) => Promise<Quote | null>;
  isSubmitting: boolean;
};

export function useDuplicateQuote(): UseDuplicateQuoteResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const duplicateQuote = async (id: string): Promise<Quote | null> => {
    setIsSubmitting(true);

    try {
      const quote = await HttpClient.post<Quote>(QUOTES_API_PATHS.DUPLICATE(id), {});

      enqueueSnackbar('Devis dupliqué', { variant: 'success' });
      return quote;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, 'Une erreur est survenue lors de la duplication du devis'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { duplicateQuote, isSubmitting };
}
